import { CompanyVoteResultSearchFilter } from '../../models/companyVoteResultSearchFilter';

export interface ICompanyVoteResultListState {
  searchFilter: CompanyVoteResultSearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

export const initialCompanyVoteResultListState: ICompanyVoteResultListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'companyName',
  ascending: true
};
